import 'core-js/stable'
import 'regenerator-runtime/runtime'

import initGlobal, { initPageFooter, initPageHeader } from '@bikemap/js/integrations/global'
import { gettext } from '@bikemap/js/services'
import { logError, parseXml, getParsedXmlValue } from '@bikemap/js/utility/helpers'
import { CoreValues } from './components'

const t = {
    OTHER: gettext('Other'),
    SEE_DETAILS: gettext('See Details'),
}

const JOBS_FETCH_URL = 'https://bikemap.jobs.personio.com/xml?language=en'
const JOBS_BASE_URL = 'https://bikemap.jobs.personio.com/'

initGlobal()
initPageHeader()
initPageFooter()

insertOpenings()
initCoreValues()

function insertOpenings() {
    const container = document.getElementById('openings-container')

    if (!container) return

    fetch(JOBS_FETCH_URL)
        .then(res => {
            if (res.ok) {
                return res.text()
            }
            return Promise.reject(res)
        })
        .then(res => {
            const internalJobsUrl = container.getAttribute('data-jobs-base-url')
            const parsed = parseXml(res, ['position'])
            if (!(parsed && parsed['workzag-jobs'] && parsed['workzag-jobs'].position)) {
                throw new Error('No jobs were found')
            }

            // Group positions by "department"
            const positions = parsed['workzag-jobs'].position.reduce((groups, item) => {
                const groupName = getParsedXmlValue(item, 'department', t.OTHER)
                return {
                    ...groups,
                    [groupName]: [...(groups[groupName] || []), item],
                }
            }, {})

            const openingsHtml = Object.keys(positions).map(group => (
                '<div class="job-opening-group">' +
                    '<h3>' + group + '</h3>' +
                    '<div class="job-opening-positions">' +
                        positions[group].map(position => {
                            const jobId = getParsedXmlValue(position, 'id', 0)
                            const jobUrl = jobId ? internalJobsUrl + jobId : JOBS_BASE_URL
                            return (
                                '<a class="job-opening" href="' + jobUrl + '">' +
                                '<span class="job-opening-details">' +
                                '<h4>' + getParsedXmlValue(position, 'name') + '</h4>' +
                                '<button class="btn btn-default">' + t.SEE_DETAILS + '</button>' +
                                '</span>' +
                                '</a>'
                            )
                        }).join('') +
                    '</div>' +
                '</div>'
            )).join('')

            // Hide loading and append fetched positions
            container.classList.remove('loading-spinner')
            container.innerHTML = openingsHtml
            // Make 'Openings' section and 'View open positions' button visible
            document.getElementById('openings').classList.remove('hidden')
            document.getElementById('open-positions-btn').classList.remove('hidden')
        })
        .catch(e => {
            logError('Fetch job positions', e)
        })
}

function initCoreValues() {
    const element = document.querySelector('.core-values')
    if (element) {
        new CoreValues().hydrate(element)
    }
}
